

























































import _ from 'lodash';
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';

import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms } from '@/const/terms/componentTerms';
import { SetActiveInventory as feedbackTerms} from '@/const/terms/feedback/activeInventory';

import { STATUS } from '@/const/status/index';
import {
    DefaultOption,
    TableOptionType,
} from '@/const/options/DefaultTableOption';
import { ID_TYPE } from '@/const/types';
import { ISearchForm, IActiveInventory, ActiveInventoryResponse, ActiveInventoryTableDataType, IActiveInventoryTableData } from './types';

import { AxiosError, AxiosResponse } from 'axios';

import Select from '@/components/ElementComponent/Select/index.vue';
import { SelectOptionType } from '@/components/ElementComponent/Select/types';
import SelectAllColumn from '@/components/ElementComponent/Column/SelectAllColumn.vue';
import StatusColumn from '@/components/ElementComponent/Column/StatusColumn.vue';
import LinkColumn from '@/components/ElementComponent/Column/LinkColumn.vue';
import { IAPP } from '../../const/types';


@Component<ActiveInventory>({
    name: 'ActiveInventory',
    components: {
        Select,
        StatusColumn,
        LinkColumn,
    },
    beforeRouteLeave (to: any, from: any, next: any) {
        if (this.isSubmit || to.name === 'login') {
            next();
        } else {
            this.$confirm(feedbackTerms.other.confirm.warnIsModified,'Warning', {
                confirmButtonText: '네',
                cancelButtonText: '아니오',
                type: 'warning'
            }).then((confirm: any) => {
                next();
            })
            .catch(() => {})
        }
    }
})
export default class ActiveInventory extends Vue {
    private terms = terms;
    private compTerms = ComponentTerms;

    private tableOptions: TableOptionType = DefaultOption;
    private loading: boolean = false;
    private isUtilsCollapsed: boolean = false;
    private saveConfirmVisible: boolean = false;
    private isSubmit: boolean = false;

    private filterForm: ISearchForm = { status: STATUS.ACTIVE, apps: [], query: '', page: 1, totalPages: 0, sort: null};
    private statusOptions: { value: STATUS; label: string; }[] = [
        { value: STATUS.ALL, label: '모든 상태'},
        { value: STATUS.ACTIVE, label: '활성' },
        { value: STATUS.INACTIVE, label: '비활성' },
    ];
    private appOptions: SelectOptionType<IAPP>[] = [];
    private tableData: ActiveInventoryTableDataType = [];

    private save() {
        this.submit().then((res: any) => res.data)
            .then((data: {result: boolean}) =>{
                if (data && data.result) {
                    this.$notify.success(feedbackTerms.save.success)
                    return;
                }
                throw new Error(feedbackTerms.save.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.save.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
    }
    
    private sortChangeHandler({ column, prop, order }: {column: any, prop: string, order: string}) {
        this.filterForm.sort = prop ? {prop: prop, order: order} : null;
        this.getActiveInventoryResponseHandler();
    }
    private changeStatus(adsets: IActiveInventoryTableData[]) {
        if (adsets.length === 0) return false;
        const adsetIds = adsets.map((item: IActiveInventoryTableData) => item.adset_id);
        let toStatus: boolean = !(((adsets[0].status as STATUS) & 1) === STATUS.INACTIVE);

        adsets.forEach((item: IActiveInventoryTableData) => {
            const s = item.status as STATUS;
            item.status = (s & ~1) | (toStatus? STATUS.ACTIVE : STATUS.INACTIVE);
        })
        this.tableData = this.tableData.map((v) => {
            const target = adsets.find((adset) => adset.adset_id === v.adset_id);
            return {
                ...v,
                status: target ? target.status : v.status,
            };
        });
    }

    private getActiveInventoryResponseHandler() {
        this.loading = true;
        this.getActiveInventoryResponse().then( (res: any) => res.data)
            .then((data: ActiveInventoryResponse) => {
                this.tableData = data.activeInventories.reduce((pre, curr) => {
                    return [...pre, ...curr.adsets.map<IActiveInventoryTableData>((v) => ({
                        campaign_id: curr.campaign_id,
                        campaign_name: curr.campaign_name,
                        weight: curr.weight,
                        adset_name: curr.adset_name,
                        adset_id: v.adset_id,
                        inventory_name: v.adset_name,
                        status: v.status,
                        begin_date: curr.begin_date,
                    }))];
                }, [] as ActiveInventoryTableDataType).sort((a, b) => `${a.begin_date}${a.adset_name}${a.inventory_name}` < `${b.begin_date}${b.adset_name}${b.inventory_name}` ? -1 : 1);
                this.filterForm.totalPages = data.pages;
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {            
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(()=>{
                this.loading = false;
            })
    }
    private getActiveInventoryResponse(){
        let sort = null
        if (this.filterForm.sort && this.filterForm.sort.prop && this.filterForm.sort.order) {
            sort = `${this.filterForm.sort.order === 'ascending'? '' : '-'}${this.filterForm.sort.prop}`;
        }
        return this.$http.adserverAPI.post('GetActiveInventories', {
            status: this.filterForm.status,
            app: this.filterForm.apps.map((item: IAPP) => item.key),
            query: this.filterForm.query,
            page_no: this.filterForm.page,
            sort: sort,
        });
    }

    private submit() {
        this.isSubmit = true;
        return this.$http.adserverAPI.post('UpdateActiveInventories', {
            activeInventories: Object.values(this.tableData.reduce((pre, curr) => {
                pre[curr.campaign_id] = {
                    campaign_id: curr.campaign_id,
                    weight: curr.weight,
                    adset_ids: [...(pre[curr.campaign_id] ? pre[curr.campaign_id].adset_ids : []), ...(((curr.status & 1) === STATUS.ACTIVE) ? [curr.adset_id] : [])],
                } as {campaign_id: string; weight: number; adset_ids: string[];};
                return pre;
            }, {} as {[key: string]: {campaign_id: string; weight: number; adset_ids: string[];}})),
        });
    }

    private created() {
        this.$http.adserverAPI.post('GetSSPAppList', {inventory: false}).then((res: any) => res.data)
            .then((data: IAPP[]) => {
                this.appOptions = data.map((item: IAPP) => {
                    return {
                        label: item.name,
                        value: item,
                    } as SelectOptionType<IAPP>;
                }).sort((a: SelectOptionType<IAPP>, b: SelectOptionType<IAPP>) => a.label < b.label ? -1 : 1);
            })
    }
    private mounted() {
        this.$nextTick( () => {
            this.getActiveInventoryResponseHandler(); 
        })
    }
}


